/**
 * Marks a demo session's mock balance (`lib/tokens.ts`) as fiction: unlabelled,
 * it reads like holdings. Wallet sessions never render it.
 */
export function DemoChip() {
  return (
    <span className="demo-chip" title="Demo balance — not real funds on chain">
      demo
    </span>
  );
}
